/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDiagLabSupplier } from 'app/shared/model/diag-lab-supplier.model';

export interface IDiagLabInventoryBill {
  id?: string;
  billNumber?: string | null;
  billDate?: number | null;
  totalCost?: number | null;
  discount?: number | null;
  cgst?: number | null;
  sgst?: number | null;
  active?: boolean | null;
  cursor?: number;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  diagLab?: IDiagLab | null;
  supplier?: IDiagLabSupplier | null;
}

export const defaultValue: Readonly<IDiagLabInventoryBill> = {
  active: false,
};
